import { createContext, useContext } from 'react'

export const ResourceRecordContext = createContext()
export const useResourceRecordContext = () => useContext(ResourceRecordContext)
